const o = (a) => {
  const m = {
    h: "-",
    hh: "--",
    H: "-",
    HH: "--",
    m: "-",
    mm: "--",
    s: "-",
    ss: "--",
    a: "AM/PM"
  };
  return a.split(/([^\w])/g).map((r) => m[r] || r).join("");
};
export {
  o as generatePlaceholderFromFormat
};
